'use strict';

angular.module('internal.applications')
    .controller('InternalStylesheetPreview', ['$scope', '$stateParams', 'XSLTStylesheets', 'Resource', '$sce', 'Upload', function ($scope, $stateParams, XSLTStylesheets, Resource, $sce, Upload) {
        $scope.loading = true;
        XSLTStylesheets.getStylesheetContent({ stylesheetID: $stateParams.id }).then(function (content) {
            if (content != null) {
                // handle IE
                var browser = Resource.browser();
                if (browser.indexOf('Edge') >= 0 || browser.indexOf('IE') >= 0) {
                    navigator.msSaveOrOpenBlob(Upload.dataUrltoBlob(content));
                    var doc = elem[0].querySelector("[id='preview']").contentWindow.document;
                    doc.open();
                    doc.write("Open PDF to preview.");
                    doc.close();
                }
                else {
                    $scope.content = $sce.trustAsResourceUrl(URL.createObjectURL(Upload.dataUrltoBlob(content)));
                }
            }

            $scope.loading = false;
        })
    }])
;